import { call, put, takeLeading } from "redux-saga/effects";
import { setAuthToken } from "../../actions/auth";
import {
  requirementActions, setRequirementData, setRequirementTechnical, setRequirementTransport
} from "../../actions/Requirement";
import { APIResponse } from "../../../utility/commonTypes";
import { getRequirementDataAsync, getRequirementTechnicalAsync, getRequirementTransportsync, updateRequirementDataAsync, updateRequirementTechnicalAsync, updateRequirementTransportAsync } from "../../../api/common";

function* RequirementTransport(action: any) {
  const { payload, callback } = action;
  try {
    let res: APIResponse = yield call(
     
        updateRequirementTransportAsync,
      payload
    );
    console.log(res.data);
   
 if (res?.status === 200) {
      yield put(setRequirementTransport({ ...res.data },function(){}));
      callback(res?.data);
    } else {
      callback(false);
    }
  } catch (error) {
    callback(false);
  }
}
function* GetRequirementTransport(action: any) {
  const { payload, callback } = action;
  try {
    let res: APIResponse = yield call(getRequirementTransportsync, payload);
    console.log(res.data);
    if (res?.status === 200) {
      yield put(setRequirementTransport({ ...res.data },function(){}));
      callback(res?.data);
    } else {
      callback(false);
    }
  } catch (error) {
    callback(false);
  }
}
export function* watchRequirementTransport() {
  yield takeLeading(requirementActions.GET_REQUIREMENT_TRANSPORT, GetRequirementTransport);
  yield takeLeading(requirementActions.UPDATE_REQUIREMENT_TRANSPORT, RequirementTransport);
}
